var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPathway(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 354.94 419.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14 {\n        stroke: #263238;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-8, .cls-11, .cls-14 {\n        stroke-width: .75px;\n      }\n\n      .cls-1, .cls-2, .cls-12 {\n        fill: none;\n      }\n\n      .cls-1, .cls-3 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-3, .cls-7, .cls-11 {\n        fill: #fff;\n      }\n\n      .cls-4, .cls-6 {\n        fill: #92e3a9;\n      }\n\n      .cls-5 {\n        fill: #b8b8b8;\n      }\n\n      .cls-15 {\n        fill: #78534e;\n      }\n\n      .cls-8 {\n        fill: #787878;\n      }\n\n      .cls-9 {\n        fill: #878787;\n      }\n\n      .cls-10 {\n        fill: #b5b5b5;\n      }\n\n      .cls-16 {\n        fill: #407bff;\n      }\n\n      .cls-13, .cls-17, .cls-14 {\n        fill: #263238;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Plant"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m5.98,367.54c2.23.42,7.16-.83,7.16-.83.05-.01-1.81-3-1.95-3.17-1.61-2.03-5.91-4.99-8.62-3.97-1.95.74-2.61,3.01-1.72,4.8.91,1.83,3.23,2.81,5.13,3.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m44.23,419.24h1.87c-.07-.15-.13-.3-.2-.46-.57-1.27-1.2-2.62-1.86-4,.3-.21,2-1.39,3.44-2.7,1.8,1.23,5.93,2.21,6.46,2.34-.22,1.35-.45,2.67-.68,3.91-.06.31-.12.61-.17.92h1.76c.03-.21.07-.41.11-.62.23-1.37.45-2.85.65-4.36.56-.01,5.1-.13,7.02-1.05,1.74-.84,3.73-2.39,4.13-4.39.4-1.96-.83-3.99-2.9-4.19-2.88-.28-6.27,3.69-7.3,6.07-.06.14-.55,1.73-.84,2.74.08-.62.17-1.22.24-1.86.16-1.26.28-2.53.42-3.89.04-.66.09-1.32.13-2,.06-.67.03-1.38.05-2.07.01-1.61-.05-3.25-.15-4.89,1.11.14,5.04.57,6.9,0,1.85-.56,4.05-1.79,4.75-3.71.69-1.88-.21-4.07-2.24-4.59-2.81-.72-6.76,2.7-8.14,4.89-.09.14-.9,1.82-1.33,2.75-.07-.99-.13-1.97-.24-2.97-.3-2.88-.68-5.78-1.06-8.68-.12-.89-.22-1.77-.33-2.66.39.05,5.06.67,7.14.03,1.85-.56,4.05-1.79,4.75-3.71.69-1.88-.21-4.07-2.24-4.59-2.81-.72-6.76,2.7-8.14,4.89-.1.16-1.27,2.59-1.54,3.22-.24-1.95-.45-3.9-.59-5.83-.19-2.66-.23-5.29-.09-7.83.18.03,5.05.69,7.18.04,1.85-.56,4.05-1.8,4.75-3.72.69-1.88-.21-4.07-2.24-4.59-2.81-.72-6.76,2.7-8.14,4.89-.11.17-1.36,2.78-1.55,3.27,0-.15,0-.31.01-.46.19-2.71.72-5.32,1.33-7.73.35-1.4.77-2.73,1.2-4,.89.22,4.99,1.16,6.97.79,1.9-.36,4.22-1.34,5.13-3.17.89-1.79.23-4.07-1.72-4.8-2.71-1.02-7.01,1.94-8.62,3.97-.09.11-.85,1.33-1.4,2.22.2-.57.4-1.17.61-1.71.77-2.05,1.61-3.88,2.36-5.49.43-.91.85-1.73,1.24-2.49.99-.25,4.95-1.28,6.51-2.51,1.52-1.19,3.13-3.13,3.09-5.18-.04-2-1.67-3.72-3.74-3.47-2.88.34-5.33,4.96-5.83,7.49-.04.22-.32,3.73-.27,3.72,0,0,.05-.01.06-.01-.39.73-.81,1.51-1.24,2.37-.79,1.6-1.66,3.42-2.48,5.46-.83,2.04-1.66,4.27-2.33,6.71-.68,2.44-1.26,5.04-1.52,7.8,0,.03,0,.06,0,.1-.18-.83-.74-3.14-.81-3.31-.9-2.43-4.06-6.59-6.95-6.46-2.08.09-3.42,2.05-3.13,4.03.29,2.02,2.19,3.68,3.88,4.61,1.91,1.05,6.62,1.41,6.99,1.44-.22,2.63-.23,5.35-.1,8.1.08,1.57.2,3.15.35,4.74-.17-.71-.34-1.35-.37-1.44-.9-2.43-4.06-6.58-6.95-6.46-2.09.09-3.42,2.05-3.13,4.03.29,2.02,2.19,3.68,3.88,4.61,1.72.95,5.73,1.33,6.79,1.42.06.61.12,1.21.18,1.82.31,2.91.64,5.81.87,8.67.08,1.01.13,2,.17,3-.16-.63-.29-1.16-.32-1.24-.9-2.43-4.06-6.58-6.95-6.46-2.09.09-3.42,2.05-3.13,4.03.29,2.02,2.19,3.68,3.88,4.61,1.64.9,5.34,1.29,6.6,1.4.02,1.02.04,2.04,0,3.03-.04.68-.02,1.33-.09,2-.06.67-.12,1.34-.17,1.99-.16,1.26-.31,2.57-.49,3.8-.12.86-.25,1.67-.38,2.49-.07-1-.25-2.96-.28-3.13-.35-1.68-1.57-4.27-3.19-5.91-.05-.25-.12-.49-.22-.73-.75-1.86-2.89-2.87-4.74-1.9-2.56,1.35-3.19,6.54-2.74,9.09.03.15.5,1.75.81,2.75-.27-.56-.53-1.11-.82-1.69-.56-1.14-1.16-2.26-1.8-3.47-.33-.57-.66-1.15-.99-1.74-.32-.59-.73-1.17-1.1-1.76-.88-1.35-1.83-2.68-2.83-3.99,1-.5,4.52-2.31,5.75-3.8,1.23-1.49,2.38-3.73,1.91-5.72-.46-1.95-2.42-3.28-4.39-2.59-2.74.95-4.15,5.98-4.09,8.57,0,.16.25,2.01.41,3.03-.6-.79-1.2-1.57-1.84-2.35-1.83-2.24-3.76-4.45-5.67-6.66-.59-.68-1.16-1.36-1.74-2.04.36-.17,4.59-2.24,5.97-3.91,1.23-1.49,2.38-3.73,1.91-5.72-.46-1.95-2.42-3.28-4.39-2.59-2.74.95-4.15,5.98-4.09,8.57,0,.19.37,2.86.49,3.53-1.27-1.5-2.53-3-3.71-4.54-1.63-2.11-3.11-4.28-4.39-6.48.17-.08,4.59-2.21,6.01-3.93,1.23-1.49,2.38-3.73,1.91-5.72-.46-1.95-2.42-3.28-4.39-2.59-2.74.95-4.15,5.98-4.09,8.57,0,.2.4,3.07.51,3.58-.08-.13-.17-.26-.24-.39-1.34-2.37-2.33-4.83-3.15-7.19-.48-1.37-.86-2.7-1.2-4,.86-.31,4.8-1.79,6.25-3.19,1.39-1.35,2.78-3.44,2.53-5.47-.25-1.99-2.05-3.52-4.08-3.06-2.82.64-4.78,5.49-5,8.07-.01.14.02,1.58.06,2.63-.15-.59-.31-1.2-.44-1.77-.49-2.14-.8-4.12-1.06-5.88-.14-1-.25-1.91-.34-2.76.69-.75,3.42-3.8,4.05-5.68.61-1.83.88-4.34-.28-6.02-1.13-1.65-3.44-2.18-5.03-.83-2.21,1.87-1.71,7.07-.72,9.46.09.21,1.79,3.28,1.83,3.25,0,0,.03-.04.04-.05.07.82.16,1.7.27,2.66.23,1.77.5,3.77.94,5.92.44,2.15.97,4.48,1.76,6.89.78,2.41,1.73,4.9,3.04,7.34.01.03.03.05.05.08-.6-.6-2.35-2.2-2.5-2.31-2.09-1.53-7.02-3.25-9.36-1.55-1.69,1.23-1.72,3.59-.39,5.09,1.36,1.53,3.86,1.86,5.78,1.71,2.17-.18,6.3-2.47,6.63-2.66,1.27,2.32,2.75,4.59,4.39,6.81.93,1.27,1.91,2.52,2.91,3.76-.54-.5-1.03-.94-1.1-.99-2.09-1.53-7.02-3.25-9.36-1.55-1.69,1.22-1.72,3.59-.39,5.09,1.36,1.53,3.86,1.86,5.78,1.71,1.95-.16,5.51-2.05,6.45-2.56.39.47.77.95,1.16,1.42,1.87,2.26,3.74,4.5,5.51,6.76.62.79,1.21,1.6,1.8,2.4-.48-.44-.89-.81-.95-.86-2.09-1.53-7.02-3.25-9.36-1.55-1.69,1.23-1.72,3.59-.39,5.09,1.36,1.53,3.86,1.86,5.78,1.71,1.86-.15,5.17-1.87,6.28-2.47.58.84,1.16,1.68,1.68,2.52.34.58.71,1.12,1.03,1.72.32.59.64,1.18.96,1.76.57,1.14,1.16,2.31,1.68,3.44.37.78.71,1.53,1.05,2.29-.61-.8-1.84-2.34-1.96-2.45-1.83-1.83-6.44-4.28-9.02-2.95-1.86.96-2.25,3.29-1.16,4.97,1.11,1.71,3.53,2.42,5.46,2.56,2.12.15,6.38-1.41,6.92-1.61.53,1.17,1.03,2.31,1.49,3.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m56.35,357.12c.05.02.14-3.5.13-3.72-.23-2.58-2.18-7.42-5-8.07-2.03-.46-3.84,1.07-4.08,3.06-.25,2.03,1.14,4.13,2.53,5.47,1.63,1.58,6.43,3.26,6.43,3.26Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m166.4,310.87s-37.83,7.19-42.02,12.91c-4.18,5.73-14.57,36.19-15.45,37.52-.88,1.32-18.72,27.97-21.36,35.67-2.64,7.71-.66,14.53,5.95,18.72,6.61,4.18,13.43,2.2,16.74,2.2s11.89-7.27,12.55-10.35,2.64-11.45,2.64-11.45l12.33-21.58,7.49,44.92h102.83l7.05-42.93,21.58,39.64h35.67l-22.24-47.34-12.33-22.24s-4.84-16.52-12.33-23.34c-7.49-6.83-17.84-9.03-21.36-9.25-3.52-.22-12.99-2.42-17.84-3.52-4.84-1.1-14.97-4.4-14.97-4.4l-44.92,4.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m96.18,386.38s12.08-1.86,23.6,7.99"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m264.44,393.57c6.76-4.32,19.11-11.62,30.3-15.02l-4.59-9.77-12.33-22.24s-4.84-16.52-12.33-23.34-17.84-9.03-21.36-9.25c-3.52-.22-12.99-2.42-17.84-3.52-4.84-1.1-14.97-4.4-14.97-4.4l-44.92,4.84s-34.32,5.58-42.02,12.91c-9.58,9.12-14.57,36.19-15.45,37.52-.4.61-4.37,6.54-8.81,13.52,4.76,3.89,15.52,11.68,28.88,15.04l8.77-15.35,7.49,44.92h102.83l7.05-42.93,9.3,17.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m166.4,310.87s-.23.08-.62.21l1.72,5.29s2.86,17.18,9.25,23.12c6.39,5.95,14.31,6.83,25.76-1.54,11.45-8.37,14.97-18.5,15.19-23.12l.22-4.62-.83-2.36c-3.19-.98-5.78-1.82-5.78-1.82l-44.92,4.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m167.58,349.14c.62,1.82,1.33,3.55,2.13,5.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m162.88,319.02s.26,13.3,3.25,25.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m158.03,318.14s-3.74,10.13-2.2,15.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m239.86,355.23c.36,1.63.83,3.23,1.4,4.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m239.51,330.47s-2.01,12.2.05,23.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m228.28,342.8s1.98,7.93,3.96,11.45"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-12",
    points: "246.11 364.38 255.14 376.49 246.55 370.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m137.77,374.51s-2.86-12.55-4.4-18.06c-1.54-5.5-1.32-15.19-1.32-15.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m121.7,345.89s2.86,5.95,8.37,9.25"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m173.45,323.87s3.52,11.23,12.77,14.09c9.25,2.86,24-14.75,25.1-19.6,1.1-4.84,1.1-9.91,1.1-10.57s-1.76-16.74-1.76-16.74c0,0-6.17,10.13-14.75,20.26-8.59,10.13-22.46,12.55-22.46,12.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m173.45,323.87s2.86,9.09,10.17,13c2.7-2.79,5.72-6.49,7.23-10.36,3.08-7.93,5.06-15.19,5.06-15.19-8.59,10.13-22.46,12.55-22.46,12.55Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m156.08,264.2s1.15,25.59,1.73,29.43c.58,3.85,4.62,14.24,5.58,17.12.96,2.89,7.31,13.85,12.89,15.39,5.58,1.54,9.62-.58,13.27-2.31,3.65-1.73,11.93-11.35,13.47-14.04,1.54-2.69,4.81-9.04,5.96-11.54l1.15-2.5s1.15-24.43,1.35-27.51c.19-3.08,2.69-15.77-.19-20.2-2.89-4.42-13.85-10.2-25.97-10.58-12.12-.38-22.89,2.69-26.93,8.08-4.04,5.39-4.81,15.2-2.31,18.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m157.62,262.27c0-1.35,2.31-1.73,2.31-1.73,0,0,11.93,9.04,19.04,8.66,7.12-.38,15.77-6.73,19.04-6.16,3.27.58,3.66,3.46,2.69,8.27-.96,4.81-1.54,11.73,0,11.93,1.54.19,4.23-.96,4.23-.96,0,0-.38,5,1.54,5.19,1.92.19,3.66-2.12,3.66-2.69s.58-8.27.58-8.27c0,0,.13-.06.35-.17.19-3.9.35-7.11.42-8.1.19-3.08,2.69-15.77-.19-20.2-2.89-4.42-13.85-10.2-25.97-10.58-12.12-.38-22.89,2.69-26.93,8.08-4.04,5.39-4.81,15.2-2.31,18.66,0,0,1.54-.58,1.54-1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m206.29,288.82s1.92-9.23,5.39-8.85c3.46.38,3.08,9.23.77,12.5-2.31,3.27-4.62,3.85-4.62,3.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m172.82,291.9s-.58,14.04-.19,15.2c.38,1.15,1.73,2.69,5.19,2.69s4.42-.96,5-2.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m169.74,311.91s1.35,1.92,3.08,2.5c1.73.58,7.12.77,9.81.38,2.69-.38,5.19-1.92,5.58-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m182.22,288.97s11.2-.6,12.53-.81c1.33-.21-3.46-2.18-7.54-2.12-4.08.06-8.01,1.07-4.99,2.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m171.46,288.91s-11.21-.49-12.54-.68c-1.33-.2,3.44-2.22,7.52-2.2,4.08.02,8.02.99,5.02,2.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m162.62,295.17s2.31,3.46,8.66,1.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m183.72,296.12s2.92,3.95,9.73.57"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 187.61,
    y: 361.17,
    width: 24.29,
    height: 48.88,
    transform: "translate(-229.9 322.43) rotate(-54.25)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 191.3,
    y: 364.88,
    width: 16.91,
    height: 41.46,
    transform: "translate(-229.9 322.43) rotate(-54.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m202,382.49c2.62,1.88,3.74,4.81,2.5,6.53-1.24,1.72-4.37,1.59-6.99-.29-2.62-1.88-3.74-4.81-2.5-6.53,1.24-1.72,4.37-1.59,6.99.29Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 191.45,
    y: 358.81,
    width: 24.29,
    height: 48.88,
    transform: "translate(-213.92 264.89) rotate(-46.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 195.14,
    y: 362.52,
    width: 16.91,
    height: 41.46,
    transform: "translate(-213.92 264.89) rotate(-46.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m206.26,380.47c2.33,2.23,3.02,5.29,1.56,6.82-1.47,1.53-4.55.96-6.88-1.27s-3.02-5.29-1.56-6.82c1.47-1.53,4.55-.96,6.88,1.27Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 195.18,
    y: 357.53,
    width: 24.29,
    height: 48.88,
    transform: "translate(-185.26 195.52) rotate(-36.1)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 198.86,
    y: 361.24,
    width: 16.91,
    height: 41.46,
    transform: "translate(-185.26 195.52) rotate(-36.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m210.42,379.7c1.9,2.61,2.05,5.73.34,6.98-1.71,1.25-4.65.15-6.55-2.46-1.9-2.61-2.05-5.73-.34-6.98,1.71-1.25,4.65-.15,6.55,2.46Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 199.88,
    y: 356.88,
    width: 24.29,
    height: 48.88,
    transform: "translate(-136.46 118.8) rotate(-23.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 203.57,
    y: 360.59,
    width: 16.91,
    height: 41.46,
    transform: "translate(-136.46 118.8) rotate(-23.93)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m215.53,379.76c1.31,2.95.8,6.04-1.14,6.9-1.94.86-4.57-.83-5.88-3.78-1.31-2.95-.8-6.04,1.14-6.9,1.94-.86,4.57.83,5.88,3.78Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 204.21,
    y: 357.17,
    width: 24.29,
    height: 48.88,
    transform: "translate(-79.13 57.38) rotate(-12.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 207.9,
    y: 360.88,
    width: 16.91,
    height: 41.46,
    transform: "translate(-79.13 57.38) rotate(-12.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m220.11,380.76c.71,3.15-.38,6.08-2.45,6.55-2.07.47-4.33-1.7-5.04-4.85-.71-3.15.38-6.08,2.45-6.55,2.07-.47,4.33,1.7,5.04,4.85Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m230.09,386.62s-17.4,6.61-18.28,7.27c-.88.66-9.47,8.59-9.91,9.69l-.44,1.1s-.22,1.54,1.32,1.54c0,0-1.76,2.64-.22,3.96,1.54,1.32,3.74.22,3.74.22,0,0-1.98,3.08.22,3.74s5.06.22,5.06.22c0,0-.44,1.1,7.27,2.64s15.85,2.2,19.38,1.54c3.52-.66,11.45-1.54,11.45-1.54,0,0,35.23,2.86,42.28,2.2,7.05-.66,18.28.44,20.48-3.08,2.2-3.52-1.1-9.91-3.74-13.87-2.64-3.96-8.81-11.45-16.07-11.67-4.4-.13-12.11,1.32-16.07,3.08s-13.21,5.5-14.09,5.73c-.88.22-10.35-.44-10.35-.44,0,0-18.28-12.11-19.38-12.33s-2.64,0-2.64,0Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-12",
    points: "202.78 406.22 216.22 398.96 231.41 395.21"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-12",
    points: "206.31 410.41 218.86 405.78 232.73 403.14"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-12",
    points: "211.59 414.37 223.92 412.61 234.93 411.29"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m109.15,388.6s10.57,5.28,11.67,5.51,7.93-.22,8.37,4.62c.44,4.84-3.96,11.45-4.84,14.31s-11.23,2.2-11.23,2.2c0,0-3.52-11.89-4.4-16.29-.88-4.4.44-10.35.44-10.35Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "104.96 370.32 117.74 412.38 121.54 416.13 121.45 410.62 108.35 369.14 104.96 370.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "108.35 369.14 104.96 370.32 106.47 375.27 109.92 374.1 108.35 369.14"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m91.75,413.04s1.32,3.74,2.64,4.18,8.81.22,11.01.22-13.65-4.4-13.65-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m94.83,404.68s-3.52,6.61-3.08,8.37c.44,1.76,3.74,2.64,6.61,3.3,2.86.66,9.47.88,12.33.66,2.86-.22-2.42-2.86-2.42-2.86,0,0-5.06-3.08-8.15-5.73-3.08-2.64-5.28-3.74-5.28-3.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m101,398.29s-5.95,3.96-6.17,6.39c-.22,2.42,6.39,8.81,7.49,9.69s8.81,2.86,11.23,2.42c2.42-.44,3.3-2.2,3.3-2.2,0,0-7.49-5.73-9.47-8.81-1.98-3.08-4.4-8.81-4.4-8.81l-1.98,1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m109.15,388.6s-8.59,2.2-8.59,5.28,3.74,12.33,5.73,14.31,8.81,7.93,10.57,6.39.66-3.08.22-4.62-5.51-14.53-5.51-14.53l-2.42-6.83Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m123.02,394.99s-7.27,13.65-5.95,14.97,3.74,2.64,4.84,1.98,5.73-6.61,7.05-9.91c1.32-3.3.44-4.62-1.54-6.17-1.98-1.54-4.4-.88-4.4-.88Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m143.14,416.96c0-1.27-1.03-2.3-2.3-2.3s-2.3,1.03-2.3,2.3,1.03,2.3,2.3,2.3,2.3-1.03,2.3-2.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 78,
    y: 416.2,
    width: 62.24,
    height: 3.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 141.62,
    y: 416.2,
    width: 62.24,
    height: 3.28
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Table"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 331.91,
    y1: 419.48,
    x2: 341.18,
    y2: 419.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 0.5,
    y1: 419.48,
    x2: 326.93,
    y2: 419.48
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Chart"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m181.85,117.1l-45.25-41.86c-10.17,10.99-16.4,25.7-16.4,41.86,0,34.05,27.6,61.65,61.65,61.65,21.76,0,40.87-11.28,51.84-28.3l-51.84-33.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m136.6,75.25l45.25,41.86,51.84,33.35c6.2-9.62,9.81-21.06,9.81-33.35,0-34.05-27.6-61.65-61.65-61.65-17.89,0-33.99,7.63-45.25,19.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m181.85,117.1l-14.36,59.96c4.61,1.1,9.41,1.7,14.36,1.7,21.76,0,40.87-11.28,51.84-28.3l-51.84-33.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m167.42,177.04l14.43-59.94-61.63-.96c0,.32-.02.64-.02.96,0,29.08,20.14,53.44,47.22,59.94Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 222.09,
    y1: 92.36,
    x2: 252.05,
    y2: 69.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 140.26,
    y1: 149.59,
    x2: 112.98,
    y2: 169.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 137.05,
    y1: 96.1,
    x2: 101.74,
    y2: 80.06
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-12",
    points: "199.63 162.97 213 197.11 236.72 197.11"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 181.85,
    cy: 117.1,
    r: 42.16
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Money_Sign",
    "data-name": "Money Sign"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m180.72,145.94v-4.74c-3.87-.15-6.76-1.41-8.66-3.78-1.9-2.37-2.94-5.73-3.13-10.1l7.22-1.41c.08,1.77.28,3.33.62,4.68.34,1.35.87,2.4,1.61,3.13.73.73,1.7,1.1,2.91,1.1,1.35,0,2.32-.4,2.91-1.21.58-.81.87-1.83.87-3.07,0-1.99-.46-3.63-1.38-4.91-.92-1.28-2.12-2.56-3.58-3.84l-5.81-5.08c-1.05-.94-1.97-1.93-2.76-2.96-.79-1.03-1.41-2.2-1.86-3.5-.45-1.3-.68-2.81-.68-4.54,0-3.42.98-6.1,2.93-8.04,1.96-1.94,4.59-3,7.9-3.19v-4.57h2.43v4.51c1.92.11,3.5.54,4.74,1.27,1.24.73,2.23,1.67,2.96,2.82.73,1.15,1.28,2.44,1.64,3.86.36,1.43.57,2.92.65,4.46l-7.11,1.24c-.08-1.43-.23-2.72-.45-3.86-.23-1.15-.65-2.05-1.27-2.71-.62-.66-1.53-.95-2.74-.87-1.28.04-2.25.45-2.91,1.24-.66.79-.99,1.79-.99,2.99,0,1.62.36,2.92,1.07,3.92.71,1,1.6,1.98,2.65,2.96l5.75,5.02c1.2,1.09,2.32,2.28,3.36,3.55,1.03,1.28,1.86,2.71,2.48,4.29.62,1.58.93,3.39.93,5.42s-.4,3.85-1.21,5.44c-.81,1.6-1.95,2.89-3.41,3.86-1.47.98-3.22,1.58-5.25,1.81v4.8h-2.43Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Bills"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 37.18,
    y: 155.62,
    width: 62.26,
    height: 83.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 44.53,
    y1: 181.11,
    x2: 92.58,
    y2: 181.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 44.53,
    y1: 192.88,
    x2: 92.58,
    y2: 192.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 44.53,
    y1: 229.15,
    x2: 92.58,
    y2: 229.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 74.44,
    y1: 181.6,
    x2: 74.44,
    y2: 232.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 48.46,
    y1: 181.6,
    x2: 48.46,
    y2: 232.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 87.68,
    y1: 181.6,
    x2: 87.68,
    y2: 232.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m53.48,175.74v-11.99h2.95c.53,0,1.01.05,1.44.15.43.1.8.26,1.11.5.31.23.55.55.72.94.17.4.25.89.25,1.5,0,.48-.07.9-.2,1.24-.13.35-.33.62-.58.82s-.58.34-.96.41c.47.08.87.24,1.18.5.31.25.54.58.7.98s.23.89.23,1.47-.07,1.08-.22,1.52c-.14.44-.36.8-.64,1.1-.28.29-.63.51-1.05.66-.42.15-.91.22-1.47.22h-3.45Zm2.19-7.09h.74c.43,0,.77-.06,1.01-.19.24-.13.4-.33.5-.59.09-.27.14-.6.14-1.01s-.07-.75-.21-.98c-.14-.23-.36-.39-.64-.47-.29-.08-.65-.13-1.1-.13h-.43v3.38Zm0,5.55h.83c.66,0,1.11-.16,1.35-.48.24-.32.36-.82.36-1.49,0-.48-.06-.88-.17-1.18-.11-.3-.3-.53-.56-.67-.26-.15-.61-.22-1.04-.22h-.76v4.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m61.78,175.74v-11.99h2.16v11.99h-2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m65.79,175.74v-11.99h2.19v10.48h2.9v1.51h-5.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m71.97,175.74v-11.99h2.19v10.48h2.9v1.51h-5.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m81.16,175.9c-.72,0-1.32-.14-1.81-.42-.48-.28-.85-.69-1.1-1.24-.25-.54-.38-1.21-.41-2l1.88-.37c.02.46.08.87.17,1.23.09.36.24.63.43.82s.45.29.76.29c.36,0,.61-.11.75-.32.15-.21.22-.48.22-.81,0-.52-.12-.95-.36-1.29-.24-.34-.55-.67-.95-1.01l-1.51-1.33c-.42-.36-.76-.77-1.01-1.22-.25-.45-.38-1-.38-1.67,0-.95.28-1.68.83-2.19.55-.51,1.31-.77,2.27-.77.56,0,1.03.09,1.41.26.38.17.67.41.9.72.22.31.39.65.5,1.04.11.39.18.8.21,1.24l-1.87.33c-.02-.38-.06-.71-.13-1.01-.06-.3-.18-.53-.34-.7-.16-.17-.4-.25-.72-.25s-.58.11-.75.32c-.17.21-.26.48-.26.79,0,.4.08.74.25,1,.17.26.41.53.73.81l1.5,1.32c.49.41.91.9,1.27,1.46.35.56.53,1.23.53,2.02,0,.57-.13,1.08-.38,1.52-.25.44-.6.79-1.05,1.04-.45.25-.97.38-1.58.38Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 30.97,
    y: 151.18,
    width: 62.26,
    height: 83.34,
    transform: "translate(43.89 -8.93) rotate(12.69)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 42.46,
    y1: 171.84,
    x2: 89.33,
    y2: 182.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 39.88,
    y1: 183.32,
    x2: 86.75,
    y2: 193.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 37.67,
    y1: 195.15,
    x2: 84.54,
    y2: 205.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 35.46,
    y1: 206.98,
    x2: 82.33,
    y2: 217.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 31.91,
    y1: 218.71,
    x2: 78.78,
    y2: 229.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 71.53,
    y1: 178.89,
    x2: 60.43,
    y2: 228.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 46.18,
    y1: 173.18,
    x2: 35.09,
    y2: 222.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 84.44,
    y1: 181.8,
    x2: 73.35,
    y2: 231.06
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m52.37,168.57l2.63-11.7,2.87.65c.52.12.98.27,1.38.46.4.19.72.43.97.73.25.3.42.65.49,1.08.08.42.05.93-.08,1.51-.11.47-.26.86-.47,1.17-.21.31-.46.53-.75.67-.29.14-.64.2-1.03.19.44.18.79.43,1.04.74s.4.68.46,1.11.03.92-.1,1.48c-.13.56-.31,1.04-.54,1.43-.24.4-.52.71-.86.93-.34.22-.73.36-1.17.41-.44.05-.94.02-1.49-.11l-3.36-.76Zm3.7-6.44l.72.16c.42.1.76.11,1.02.03.26-.07.46-.23.61-.47.15-.24.27-.56.36-.95.09-.41.1-.75,0-1.01-.09-.26-.26-.46-.52-.6-.26-.14-.61-.27-1.04-.36l-.42-.09-.74,3.29Zm-1.22,5.42l.81.18c.64.15,1.12.09,1.42-.17.3-.26.53-.72.67-1.37.11-.47.14-.87.09-1.19-.04-.32-.18-.58-.4-.78-.22-.2-.55-.35-.97-.45l-.74-.17-.89,3.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m60.47,170.39l2.63-11.7,2.11.48-2.63,11.7-2.11-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m64.38,171.27l2.63-11.7,2.14.48-2.3,10.23,2.83.64-.33,1.47-4.97-1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m70.4,172.63l2.63-11.7,2.14.48-2.3,10.23,2.83.64-.33,1.47-4.97-1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m79.34,174.81c-.7-.16-1.26-.43-1.67-.81-.41-.38-.68-.86-.8-1.45-.12-.58-.11-1.26.03-2.04l1.92.05c-.08.46-.12.87-.1,1.24.01.37.09.67.24.9.15.23.37.38.68.45.35.08.62.03.81-.15.19-.17.32-.42.39-.74.11-.51.09-.96-.06-1.33-.16-.38-.39-.78-.7-1.19l-1.18-1.63c-.33-.45-.57-.92-.72-1.41-.15-.49-.15-1.06,0-1.71.21-.92.64-1.58,1.29-1.96.65-.38,1.45-.46,2.38-.25.55.12.99.31,1.31.56.33.25.57.55.72.9.15.35.23.72.25,1.13.02.4,0,.82-.07,1.25l-1.89-.09c.06-.37.1-.71.1-1.01,0-.3-.06-.55-.18-.75-.12-.2-.34-.33-.65-.4-.32-.07-.58-.02-.8.15-.22.17-.36.41-.43.72-.09.39-.08.74.03,1.03.11.29.28.61.53.95l1.17,1.61c.39.51.69,1.08.91,1.7.22.62.24,1.32.07,2.09-.13.56-.36,1.03-.7,1.4-.34.38-.76.64-1.25.79-.49.15-1.03.15-1.62.02Z"
  })))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Car"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m328.42,205.19v17.32h-67.69v-17.32h-12.73v25.31c0,1.96,1.59,3.55,3.55,3.55h5.62c1.96,0,3.55-1.59,3.55-3.55v-1.17h6.17l2.89-1.84h49.33l3.67,2.1h5.64v.91c0,1.96,1.59,3.55,3.55,3.55h5.62c1.96,0,3.55-1.59,3.55-3.55v-25.31h-12.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m338.52,192.73c-.47-.94-3.91-4.54-4.6-5.25-.08-.08-.15-.18-.2-.28-.84-1.61-7.98-13.36-9.23-15.7-2.3-4.28-4.14-3.64-6.59-3.95-.07,0-.14.01-.22,0l-18.63-.94c-3.07-.16-6.14-.16-9.21,0-5.04.25-10.08.5-15.12.76-4.21.21-8.26-.06-10.57,4.13-1.28,2.32-8.39,14.08-9.23,15.7-.05.1-.12.2-.2.28-.69.72-4.13,4.31-4.6,5.25-.52,1.05-2.62,4.99-2.62,5.77,0,.68.49,11.9,2.64,20.7.64,2.62,2.63,4.72,5.23,5.46.18.05.32.08.4.08h16.34c.44,0,.85-.24,1.07-.62l3.87-6.68c.08-.13.18-.25.29-.34.61-.49,2.66-1.94,5.72-1.94h22.56c3.05,0,5.11,1.45,5.72,1.94.12.1.22.21.29.34l3.87,6.68c.22.38.63.62,1.07.62h16.34c.07,0,.21-.03.39-.08,2.6-.73,4.58-2.83,5.23-5.46,2.16-8.8,2.64-20.02,2.64-20.7,0-.79-2.1-4.72-2.62-5.77Zm-80.15-8.4c3.28-6.43,9.45-14.28,9.45-14.28,30.04-3.02,53.13-.13,53.13-.13l8.92,14.41c-20.33-1.97-71.5,0-71.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m272.8,224.73l-.92,2.1h44.6l-.66-2.1-4.33-7.48s-1.71-1.97-5.9-2.1c-4.2-.13-22.56,0-22.56,0,0,0-3.15-.26-5.9,2.1l-4.33,7.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m276.6,199.81s3.54,6.3,4.59,7.35,2.23,1.05,3.67,1.18c1.44.13,21.25,0,21.25,0,0,0,1.57-.26,2.36-1.44.79-1.18,3.41-7.08,3.41-7.08h-35.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m280.11,200.66s2.84,5.04,3.68,5.88c.84.84,1.79.84,2.94.95,1.16.1,17.02,0,17.02,0,0,0,1.26-.21,1.89-1.16.63-.95,2.73-5.67,2.73-5.67h-28.26Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m309.04,222.5l-.78-2.17c-.5-1.37-1.81-2.27-3.27-2.24l-21.31.21c-1.5.03-2.81,1.04-3.21,2.49l-.53,1.71h29.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "279.61 223.55 278.96 225.65 310.18 225.65 309.42 223.55 279.61 223.55"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m333.8,187.35s.66-5.12,1.84-5.12,6.43,1.44,6.56,2.49c.13,1.05-1.05,2.23-2.1,2.49s-3.28.52-3.28.52l-.52,1.97-2.49-2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m254.82,187.35s-.66-5.12-1.84-5.12-6.43,1.44-6.56,2.49c-.13,1.05,1.05,2.23,2.1,2.49,1.05.26,3.28.52,3.28.52l.52,1.97,2.49-2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m270.04,199.15s2.36,2.49,3.15,7.08c0,0-11.15-.52-15.48-2.23-4.33-1.71-4.85-1.84-4.99-2.62s.26-6.43,1.97-7.35c1.71-.92,3.54-.66,5.25.66,1.71,1.31,3.8,3.28,4.99,3.67,1.18.39,5.12.79,5.12.79Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 259.32,
    cy: 199.53,
    r: 3.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m267.89,203.38c0,.79-.64,1.43-1.43,1.43s-1.43-.64-1.43-1.43.64-1.43,1.43-1.43,1.43.64,1.43,1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m318.95,199.15s-2.36,2.49-3.15,7.08c0,0,11.15-.52,15.48-2.23,4.33-1.71,4.85-1.84,4.98-2.62s-.26-6.43-1.97-7.35c-1.71-.92-3.54-.66-5.25.66-1.71,1.31-3.8,3.28-4.99,3.67-1.18.39-5.12.79-5.12.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m327.3,199.53c0,1.7,1.38,3.07,3.07,3.07s3.07-1.38,3.07-3.07-1.38-3.07-3.07-3.07-3.07,1.38-3.07,3.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m321.81,203.38c0,.79.64,1.43,1.43,1.43s1.43-.64,1.43-1.43-.64-1.43-1.43-1.43-1.43.64-1.43,1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m333.01,210.83s-12.2,2.36-12.73,2.75c-.52.39-1.57,2.62-1.57,2.62l2.49-.66s5.77.26,7.74-.66,4.07-4.07,4.07-4.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m256.53,210.83s12.2,2.36,12.73,2.75c.52.39,1.57,2.62,1.57,2.62l-2.49-.66s-5.77.26-7.74-.66-4.07-4.07-4.07-4.07Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "317.72 201.17 314.46 200.09 311.89 200.09"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "271.49 201.02 273.66 199.78 276.6 199.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m326.95,186.5c.33-.19.67-.37,1-.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m312.51,205.12c2.05-4.51,6.75-13.48,13.3-17.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m311.36,207.84s.16-.43.47-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m262.78,187.21c-.54-.33-1.11-.64-1.69-.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m275.92,205.22c-1.34-4.01-4.84-12.32-11.98-17.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m276.61,207.53s-.1-.42-.31-1.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m257.37,193.57s-1.4-3.41-1.4-5.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m331.99,193.42s.47-1.55.78-4.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m336.8,208l-.93,12.1-17.22.78s-2.95-3.57-3.1-5.12c-.16-1.55,2.02-3.88,2.64-4.03.62-.16,11.48-2.33,11.48-2.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m252.55,208l.93,12.1,17.22.78s2.95-3.57,3.1-5.12c.16-1.55-2.02-3.88-2.64-4.03s-11.48-2.33-11.48-2.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m281.34,202.73l12.66,1.01c.54.04,1.08.04,1.62,0l11.67-.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m282.18,204.06l11.82.95c.54.04,1.08.04,1.62,0l11.26-.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m283.02,205.38l10.98.88c.54.04,1.08.04,1.62,0l10.69-.83"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m258.36,184.33s51.16-1.97,71.5,0l-8.92-14.41s-23.09-2.89-53.13.13c0,0-6.17,7.85-9.45,14.28Z"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "House"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 243.41,
    y: 30.11,
    width: 104.58,
    height: 33
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "295.84 0 243.68 30.11 347.99 30.11 295.84 0"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 291.01,
    y: 27.43,
    width: 25.88,
    height: 35.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 291.01,
    y: 27.43,
    width: 25.88,
    height: 1.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m310.41,63.11h-12.92v-22.3c0-3.57,2.89-6.46,6.46-6.46h0c3.57,0,6.46,2.89,6.46,6.46v22.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 235.9,
    y: 35.89,
    width: 59.95,
    height: 27.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 235.9,
    y: 35.89,
    width: 59.95,
    height: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 242.49,
    y: 38.14,
    width: 46.75,
    height: 24.98
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "265.87 15.98 234.06 34.34 297.68 34.34 265.87 15.98"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 234.06,
    y: 34.34,
    width: 63.63,
    height: 1.55
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "303.95 17.07 287.47 26.58 320.42 26.58 303.95 17.07"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 287.47,
    y: 26.58,
    width: 32.95,
    height: 1.53
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 244.2,
    y: 40.14,
    width: 3.79,
    height: 3.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 249.88,
    y: 40.14,
    width: 3.79,
    height: 3.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 255.56,
    y: 40.14,
    width: 3.79,
    height: 3.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 261.23,
    y: 40.14,
    width: 3.79,
    height: 3.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 266.91,
    y: 40.14,
    width: 3.79,
    height: 3.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 272.59,
    y: 40.14,
    width: 3.79,
    height: 3.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 278.27,
    y: 40.14,
    width: 3.79,
    height: 3.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 283.95,
    y: 40.14,
    width: 3.79,
    height: 3.79
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 244.2,
    y: 45.72,
    width: 3.79,
    height: 3.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 249.88,
    y: 45.72,
    width: 3.79,
    height: 3.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 255.56,
    y: 45.72,
    width: 3.79,
    height: 3.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 261.23,
    y: 45.72,
    width: 3.79,
    height: 3.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 266.91,
    y: 45.72,
    width: 3.79,
    height: 3.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 272.59,
    y: 45.72,
    width: 3.79,
    height: 3.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 278.27,
    y: 45.72,
    width: 3.79,
    height: 3.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 283.95,
    y: 45.72,
    width: 3.79,
    height: 3.79
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 244.2,
    y: 51.29,
    width: 3.79,
    height: 3.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 249.88,
    y: 51.29,
    width: 3.79,
    height: 3.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 255.56,
    y: 51.29,
    width: 3.79,
    height: 3.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 261.23,
    y: 51.29,
    width: 3.79,
    height: 3.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 266.91,
    y: 51.29,
    width: 3.79,
    height: 3.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 272.59,
    y: 51.29,
    width: 3.79,
    height: 3.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 278.27,
    y: 51.29,
    width: 3.79,
    height: 3.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 283.95,
    y: 51.29,
    width: 3.79,
    height: 3.79
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 244.2,
    y: 56.86,
    width: 3.79,
    height: 3.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 249.88,
    y: 56.86,
    width: 3.79,
    height: 3.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 255.56,
    y: 56.86,
    width: 3.79,
    height: 3.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 261.23,
    y: 56.86,
    width: 3.79,
    height: 3.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 266.91,
    y: 56.86,
    width: 3.79,
    height: 3.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 272.59,
    y: 56.86,
    width: 3.79,
    height: 3.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 278.27,
    y: 56.86,
    width: 3.79,
    height: 3.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 283.95,
    y: 56.86,
    width: 3.79,
    height: 3.79
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "350.95 63.11 312.72 63.11 312.72 27.43 331.83 17.07 350.95 27.43 350.95 63.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "353.88 28.95 331.83 17.01 309.79 28.95 309.11 27.68 331.83 15.37 354.56 27.68 353.88 28.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "312.72 27.43 312.72 28.3 331.83 17.94 350.95 28.3 350.95 27.43 331.83 17.07 312.72 27.43"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 332.45,
    y: 39.66,
    width: 6.42,
    height: 4.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 332.45,
    y: 45.58,
    width: 6.42,
    height: 4.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 332.45,
    y: 33.43,
    width: 6.42,
    height: 4.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 324.57,
    y: 33.43,
    width: 6.42,
    height: 4.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 324.57,
    y: 45.58,
    width: 6.42,
    height: 4.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 324.57,
    y: 39.66,
    width: 6.42,
    height: 4.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 332.45,
    y: 51.51,
    width: 6.42,
    height: 4.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 324.57,
    y: 51.51,
    width: 6.42,
    height: 4.1
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Piggy_Bank",
    "data-name": "Piggy Bank"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m82.55,21.06s9.48-5.34,10.86-4.83c1.38.52-1.21,11.03-1.55,11.72s-9.31-6.9-9.31-6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m92.9,17.61s-.41.64-.93,1.56c-.91,1.61-2.17,4.08-2.17,5.51,0,2.24,1.38,2.07,1.72.34l1.21-5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m17.92,42.98c0,3.38-2.11,6.13-4.71,6.13s-4.71-2.74-4.71-6.13,2.11-6.13,4.71-6.13,4.71,2.74,4.71,6.13Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 55.88,
    cy: 48.98,
    rx: 44.85,
    ry: 37.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m85,75.16c-7.6,6.07-17.85,9.79-29.13,9.79-20.12,0-36.98-11.85-41.36-27.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m13.43,50.18c-.02-.4-.02-.79-.02-1.19,0-4.42.94-8.66,2.67-12.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m42.41,15.19c4.23-1.21,8.76-1.86,13.47-1.86s9.28.66,13.52,1.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m98.24,37.26s5.69-1.9,6.55-.86c.86,1.03.86,13.1.17,15.34s-5.34,1.72-8.62-.69-2.93-5.86-2.93-5.86"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 94.79,
    y1: 44.68,
    x2: 91.35,
    y2: 45.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m93.93,48.47s-.86,6.03.17,6.21,2.76-2.93,2.76-2.93c0,0-2.41-2.76-2.93-3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m90.8,34.34c.32,1.24.13,2.37-.42,2.51-.55.14-1.26-.75-1.58-2-.32-1.24-.13-2.37.42-2.51.55-.14,1.26.75,1.58,2Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m72.68,17.63s10.85-10.85,12.97-8.73c2.12,2.12,1.32,11.38,1.32,12.7v3.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m86,11.23s.17-2.76-1.03-1.03c-1.21,1.72-4.65,13.62-3.62,15,1.03,1.38,3.97.69,4.65-1.9.69-2.59.17-10,.17-10"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-16",
    points: "26.62 74.15 32.56 90.19 39.11 90.19 42.04 81.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-16",
    points: "81.35 76.23 75.66 90.19 69.11 90.19 66.18 81.91"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPathway);
export default __webpack_public_path__ + "static/media/pathway.1a36880add98defda58ebf0f3104115b.svg";
export { ForwardRef as ReactComponent };